import { useCallback } from 'react';
import { userInfoApi } from '../services/apiServices/user/userInfo';
import { BRIZ_TV_LINK } from '../constants/configuration';

export const UseGetAuthLinkBrizTv = () => {
  const [getToken, { isFetching }] = userInfoApi.useLazyGetAuthTokenBrizTvQuery();

  const getAuthLinkBrizTv = useCallback(async () => {
    try {
      const { code } = await getToken().unwrap();
      return `${BRIZ_TV_LINK}?token=${encodeURIComponent(code)}`;
    } catch {
      return BRIZ_TV_LINK;
    }
  }, [getToken]);

  return { getAuthLinkBrizTv, isLoadingGetAuthLinkBrizTv: isFetching };
};
